__turbopack_context__.v({
  "article": "_3LjAPq_article",
  "button": "_3LjAPq_button",
  "container": "_3LjAPq_container",
  "hideOnMd": "_3LjAPq_hideOnMd",
  "hideOnSm": "_3LjAPq_hideOnSm",
  "hideOnXs": "_3LjAPq_hideOnXs",
  "iconNext": "_3LjAPq_iconNext",
  "largeArticleImage": "_3LjAPq_largeArticleImage",
  "next": "_3LjAPq_next",
  "prev": "_3LjAPq_prev",
  "recomended": "_3LjAPq_recomended",
  "slide": "_3LjAPq_slide",
});
